import { render, staticRenderFns } from "./ObjectsTreeNode.vue?vue&type=template&id=33dbb54e"
import script from "./ObjectsTreeNode.vue?vue&type=script&lang=ts"
export * from "./ObjectsTreeNode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports